import React, { useState } from 'react';
import ItinerarySegmentBanner from '@kiwicom/orbit-components/lib/Itinerary/ItinerarySegment/ItinerarySegmentBanner';
import { ThrowawayItineraryData } from '@kiwicom/openapi-sdk/mmb';

import ItineraryBadgeList from '../ItineraryBadgeList';
import { useItineraryContext } from '../../services/context/itineraryContext';
import { ThrowAwayBannerAction } from '../../services/types';
import SmartFaqLink, { articleIds } from '@kiwicom/overlord/src/components/SmartFaqLink';
import ItinerarySegmentBannerWithRef from './ItinerarySegmentBannerWithRef';
import ThrowAwayTicketModal from '../modals/ThrowAwayTicketModal';

type ThrowAwayTicketBannerProps = {
  throwAwayInfo: ThrowawayItineraryData;
};

/**
 * Component which renders a ItinerarySegmentBanner containing a list of badges connected to the TAT segment info.
 * After clicking on the banner, the ThrowAwayTicketModal is opened.
 *
 * @param throwAwayInfo - information about throwaway part of the segment (containing list of badges)
 *
 * @returns ThrowAwayTicketBanner component
 */
const ThrowAwayTicketBanner = ({ throwAwayInfo }: ThrowAwayTicketBannerProps) => {
  const [isThrowAwayModalOpened, setIsThrowAwayModalOpened] = useState(false);
  const { throwAwayBannerAction } = useItineraryContext();

  return (
    <>
      {isThrowAwayModalOpened && (
        <ThrowAwayTicketModal onClose={() => setIsThrowAwayModalOpened(false)} />
      )}
      {throwAwayBannerAction === ThrowAwayBannerAction.openSfaq ? (
        <SmartFaqLink articleId={articleIds.THROW_AWAY_TICKET_ARTICLE} legacyBehavior>
          <ItinerarySegmentBannerWithRef>
            <ItineraryBadgeList badges={throwAwayInfo.badges} spaceAfter="none" spacing="200" />
          </ItinerarySegmentBannerWithRef>
        </SmartFaqLink>
      ) : (
        <ItinerarySegmentBanner onClick={() => setIsThrowAwayModalOpened(true)}>
          <ItineraryBadgeList badges={throwAwayInfo.badges} spaceAfter="none" spacing="200" />
        </ItinerarySegmentBanner>
      )}
    </>
  );
};

export default ThrowAwayTicketBanner;
